<template>
    <Card dis-hover>
        <p slot="title">
            <Icon type="ios-bookmark"></Icon>
            修改密码
        </p>
        <Form ref="userForm" :rules="userRule" :model="user" :label-width="120" style="width: 520px">
            <FormItem label="登录账号">
                {{ userName }}
            </FormItem>
            <FormItem label="原始密码" prop="currentPassword">
                <Input v-model="user.currentPassword" type="password"></Input>
            </FormItem>
            <FormItem label="新密码" prop="newPassword">
                <Input v-model="user.newPassword" :maxlength="32" type="password"></Input>
            </FormItem>
            <FormItem label="重复密码" prop="confirmPassword">
                <Input v-model="user.confirmPassword" :maxlength="32" type="password"></Input>
            </FormItem>
            <FormItem>
                <Button @click="save" type="primary">确认</Button>
                &nbsp;&nbsp;
            </FormItem>
        </Form>
    </Card>
</template>
<script>
import util from '@/lib/util';
export default {
    components: {},
    name: 'password',
    data() {
        return {
            user: {},
            userRule: {
                currentPassword: [{ required: true, message: '必填项不能为空', trigger: 'blur' }],
                newPassword: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' },
                    { validator: this.passwordValid, message: '密码长度8-20位且必须包含大小写字母，数字和以下特殊字符#?!@$%^*-', trigger: 'blur' },
                ],
                confirmPassword: [
                    { required: true, message: '必填项不能为空', trigger: 'blur' },
                    { validator: this.validatePassCheck, message: '两次密码不一致', trigger: 'blur' },
                ],
            },
            userName: '',
        };
    },
    mounted() {
        setTimeout(() => {
            this.userName = this.$store.state.session.user.userName ? this.$store.state.session.user.userName : '';
        });
    },
    activated() {
        this.userName = this.$store.state.session.user.userName ? this.$store.state.session.user.userName : '';
        console.log(this.userName, '-------------');
    },
    methods: {
        async save() {
            this.$refs.userForm.validate(async valid => {
                if (valid) {
                    let reponse = await this.$Ajax.post(`/api/services/app/User/ChangePassword`, this.user);
                    if (reponse.data.success) {
                        this.$Message.success('修改成功，请重新登录');
                        let _this = this;
                        setTimeout(() => {
                            _this.$store.commit('app/logout', _this);
                            util.abp.auth.clearToken();
                            location.reload();
                        });
                    }
                }
            });
        },
        passwordValid(rule, value, callback) {
            let reg = /^(?=.*[0-9].*)(?=.*[a-z].*)(?=.*[A-Z].*)(?=.*[#?!@$%^*-].*).{8,20}$/;
            if (!value) {
                callback(new Error('必填项不能为空'));
            } else if (!reg.test(value)) {
                callback(new Error('密码长度8-20位且必须包含大小写字母，数字和以下特殊字符#?!@@$%^*-'));
            } else {
                callback();
            }
        },
        validatePassCheck(rule, value, callback) {
            if (!value) {
                callback(new Error('必填项不能为空'));
            } else if (value !== this.user.newPassword) {
                callback(new Error('两次密码不一致'));
            } else {
                callback();
            }
        },
    },
};
</script>
<style lang="less" scoped>
.group {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
}
</style>
